import React from "react";
import styled, { keyframes } from "styled-components";

const scrollAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  background: transparent;
  padding: 4rem 0;
  display: flex;
  align-items: center;
  overflow-x: hidden;
  position: relative;
  
  /* Create the fade out and strict spotlight on the center */
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    rgba(0, 0, 0, 1) 15%,
    rgba(0, 0, 0, 1) 85%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    rgba(0, 0, 0, 1) 15%,
    rgba(0, 0, 0, 1) 85%,
    transparent 100%
  );

  /* Center spotlight effect removed to prevent discoloration against the global gradient */

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

const LogoTrack = styled.div`
  display: flex;
  width: calc(200%);
  animation: ${scrollAnimation} 50s linear infinite;
  align-items: center;
  gap: 3rem;

  &:hover {
    animation-play-state: paused;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  padding: 0 30px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 80px;

  @media (max-width: 768px) {
    padding: 0 15px;
    height: 80px;
  }
`;

const Png = styled.img`
  max-width: 120px;
  max-height: 70px;
  min-width: 80px;
  object-fit: contain;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 20px;

  &:hover {
    transform: scale(1.2) translateY(-4px);
  }

  @media (max-width: 768px) {
    max-width: 140px;
    max-height: 80px;
    min-width: 100px;
    padding: 0 10px;
  }
`;

const logos = [
  { src: "/jeromesig.png", alt: "Jerome Belau" },
  { src: "/WNLogo.png", alt: "Wincor Nixdorf" },
  { src: "/reslogo.png", alt: "Resilient Risk Consultant" },
  { src: "/TLAwhite.png", alt: "TLA Worldwide" },
  { src: "/ss.png", alt: "The Swing Suite" },
  { src: "/Hoy.png", alt: "Chris Hoy" },
  { src: "/Tesco.png", alt: "Tesco" },
  { src: "/royal.png", alt: "Royal Tutors" },
  { src: "/Kaiteriterilogo.png", alt: "KRR" },
  { src: "/kmtblogo.png", alt: "KMTB" },
  { src: "/swike.png", alt: "Swike" },
  { src: "/Microsoft.png", alt: "Microsoft" },
];

const Partners = () => {
  return (
    <Container>
      <LogoTrack>
        {logos.concat(logos).map((logo, index) => (
          <LogoWrapper key={index}>
            <Png src={logo.src} alt={logo.alt} />
          </LogoWrapper>
        ))}
      </LogoTrack>
    </Container>
  );
};

export default Partners;
